<template>
  <div class="inquirySelect">
    <el-dialog
      title="问诊单"
      :visible.sync="visible"
      width="760px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content">
        <div class="left">
          <div class="search">
            <el-input class="search_input" size="mini" v-model="search" prefix-icon="el-icon-search" clearable placeholder="模版名称" @input="searchInput"></el-input>
          </div>
          <div v-if="![null, undefined, ''].includes(search)" class="search_result">搜索到 {{ templateList.length }} 条信息</div>
          <div v-else class="tab">
            <el-tabs class="tab_tabs" v-model="tabActive" @tab-click="tabOn">
              <el-tab-pane label="公共模版" name="0"></el-tab-pane>
              <el-tab-pane label="个人模版" name="1"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="list" v-loading="templateListLoading">
            <div v-for="inquiry in templateList" :key="inquiry.id" :class="{ list_item: true, active: inquiry.id === templateActiveId }" @click="templateOn(inquiry.id)">
              <div class="list_item_info">
                <span class="el-icon-document list_item_info_icon"></span>
                <span class="list_item_info_name">{{ inquiry.templateName }}</span>
              </div>
              <div v-if="![null, undefined, ''].includes(search)" class="list_item_tag">
                <el-tag v-if="inquiry.templateType === '0'" size="mini">公共</el-tag>
                <el-tag v-if="inquiry.templateType === '1'" size="mini" type="success">个人</el-tag>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="orderInfo.templateDescribe" class="order_description">{{ orderInfo.templateDescribe }}</div>
          <div class="question_list">
            <div v-for="(quest, questIndex) in orderInfo.questions" :key="quest.id" class="question_item">
              <div class="question_title">
                <span v-if="quest.required" class="question_title_required">*</span>
                <span class="question_title_text">{{ questIndex + 1 }}.{{ quest.questionsTitle }}</span>
              </div>
              <div v-if="quest.questionDescribe" class="question_description">{{ quest.questionDescribe }}</div>
              <div v-if="quest.sampleImages.length > 0" class="question_example">
                <img v-for="(exampleImg, exampleImgIndex) in quest.sampleImages" :key="exampleImgIndex" class="question_example_img" :src="exampleImg">
              </div>
              <div class="question_answer">
                <div v-if="quest.questionsType === 0" class="answer_single">
                  <el-radio v-for="ans in quest.answers" :key="ans.id" class="answer_single_radio" value="0" disabled>{{ ans.answerContent }}</el-radio>
                </div>
                <div v-if="quest.questionsType === 1" class="answer_multiple">
                  <el-checkbox v-for="ans in quest.answers" :key="ans.id" class="answer_multiple_checkbox" value="0" disabled>{{ ans.answerContent }}</el-checkbox>
                </div>
                <div v-if="quest.questionsType === 2" class="answer_shortAnswer">
                  <div v-show="quest.answerType.includes('1')" class="answer_shortAnswer_img">
                    <div class="answer_shortAnswer_img_header">
                      <div class="answer_shortAnswer_img_title">图片上传</div>
                      <div class="answer_shortAnswer_img_tips">限jpg/png文件，最多上传5张</div>
                    </div>
                    <div class="answer_shortAnswer_img_upload">
                      <span class="el-icon-plus answer_shortAnswer_upload_icon"></span>
                    </div>
                  </div>
                  <div v-show="quest.answerType.includes('2')" class="answer_shortAnswer_text">
                    <el-input class="answer_shortAnswer_text_input" placeholder="请输入" disabled></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" :loading="sendLoading" @click="send">发 送</el-button>
        <el-button @click="close">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { debounce } from '@/utils/validateBase'

  import { templateList } from '@/api/consultation-questionnaire'
  import { sendIquiry } from "@/api/webchat"
  export default {
    name: 'inquirySelect',
    data () {
      return {
        visible: false,
        templateListLoading: false,
        sendLoading: false,
        webChatOrderInfoId: '',
        doctorId: '',
        search: '',
        tabActive: '0',
        templateActiveId: '',
        templateList: []
      }
    },
    methods: {
      async getTemplateList () {
        this.templateListLoading = true
        console.log(this.tabActive)
        const res = await templateList({
          doctorId: this.tabActive === '1' || ![null, undefined, ''].includes(this.search) ? this.doctorId : '',
          templateName: this.search,
          templateType: [null, undefined, ''].includes(this.search) ? this.tabActive : null,
          isGetCommon: ![null, undefined, ''].includes(this.search) ? 1 : null
        })
        this.templateListLoading = false
        if (res.code === 200) {
          this.templateList = res.rows
        }
      },
      searchInput: debounce(function () {
        this.templateActiveId = ''
        this.getTemplateList()
      }, 400),
      tabOn () {
        this.templateActiveId = ''
        this.getTemplateList()
      },
      templateOn (id) {
        this.templateActiveId = id
      },
      open (info) {
        this.visible = true
        this.webChatOrderInfoId = info.webChatOrderInfoId
        this.doctorId = info.doctorId
        this.getTemplateList()
      },
      close () {
        this.visible = false
        this.search = ''
        this.tabActive = '0'
        this.templateActiveId = ''
        this.templateList = []
      },
      async send () {
        this.sendLoading = true
        const res = await sendIquiry({
          deptId: process.env.VUE_APP_CHAT_DEPT_ID,
          webChatOrderInfoId: this.webChatOrderInfoId,
          templateId: this.templateActiveId
        })
        this.sendLoading = false
        if (res.code === 200) {
          this.$message.success('发送成功')
          this.close()
        }
      }
    },
    computed: {
      orderInfo () {
        const info = this.templateList.find(v => v.id === this.templateActiveId)
        if (info) {
          const result = JSON.parse(JSON.stringify(info))
          result.questions.map(v => {
            v.answerType = [null, undefined, ''].includes(v.answerType) ? [] : v.answerType.split(',')
            v.sampleImages = [null, undefined, ''].includes(v.sampleImages) ? [] : v.sampleImages.split(',')
            return v
          })
          return result
        } else {
          return {
            id: '',
            templateName: '',
            questions: []
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .inquirySelect /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #EBEAEE !important;
  }

  .inquirySelect /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .inquirySelect /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .inquirySelect /deep/ .el-dialog__body {
    padding: 0;
  }

  .inquirySelect /deep/ .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #EBEAEE;
  }

  .content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 500px;
    overflow: hidden;
  }

  .left {
    box-sizing: border-box;
    width: 240px;
    height: 100%;
    background-color: #FAFBFC;
    border-right: 1px solid #EBEAEE;
  }

  .search {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #EBEAEE;
  }

  .search_input {
    width: 100%;
    max-width: 100% !important;
  }

  .search_result {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    font-size: 14px;
    color: #667182;
    border-bottom: 1px solid #EBEAEE;
  }

  .tab {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 32px;
    border-bottom: 1px solid #EBEAEE;
  }

  .tab_tabs {
    margin: 0 0 0 0 !important;
    width: 100%;
    height: 100%;
    border: none;
  }

  .tab_tabs /deep/ .el-tabs__header {
    margin: 0 0 0 0 !important;
    padding: 0 0 0 0 !important;
  }

  .tab_tabs /deep/ .el-tabs__item{
    height: 32px;
    line-height: 32px;
    color: #667182;
  }

  .tab_tabs /deep/ .el-tabs__item.is-active{
    color: #1F2329;
  }

  .list {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 40px - 32px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list_item {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 36px;
    cursor: pointer;
  }

  .list_item.active {
    background-color: #E8F4FF;
  }

  .list_item_info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .list_item_info_icon {
    font-size: 16px;
    color: #1890FF;
  }

  .list_item_info_name {
    margin: 0 0 0 8px;
    max-width: 120px;
    font-size: 14px;
    color: #1F2329;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .list_item_tag {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .right {
    box-sizing: border-box;
    padding: 12px 16px;
    width: calc(100% - 240px);
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .order_description {
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .question_list {
    width: 100%;
  }

  .order_description+.question_list {
    margin: 12px 0 0 0;
  }

  .question_item {
    box-sizing: border-box;
    width: 100%;
  }

  .question_item+.question_item {
    margin: 12px 0 0 0;
  }

  .question_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .question_title_required {
    font-size: 14px;
    color: #F54A45;
    vertical-align: middle;
  }

  .question_title_text {
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    vertical-align: middle;
  }

  .question_description {
    margin: 12px 0 0 0;
    width: 100%;
    line-height: 22px;
    font-size: 14px;
    color: #505050;
    white-space: pre-wrap;
  }

  .question_example {
    margin: 12px -12px -12px 0;
    width: 100%;
  }

  .question_example_img {
    margin: 0 12px 12px 0;
    width: 80px;
    height: 80px;
  }

  .question_answer {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .answer_single {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  
  .answer_single_radio+.answer_single_radio {
    margin: 12px 0 0 0;
  }

  .answer_multiple {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .answer_multiple_checkbox+.answer_multiple_checkbox {
    margin: 12px 0 0 0;
  }

  .answer_shortAnswer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .answer_shortAnswer_img {
    margin: 0 0 0 0;
  }

  .answer_shortAnswer_img_header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .answer_shortAnswer_img_title {
    line-height: 18px;
    font-size: 14px;
    color: #323233;
  }

  .answer_shortAnswer_img_tips {
    margin: 0 0 0 6px;
    line-height: 18px;
    font-size: 12px;
    color: #606266;
  }

  .answer_shortAnswer_img_upload {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 0 0;
    width: 148px;
    height: 148px;
    background-color: #F9F9FA;
    border: 1px dashed #DCDFE6;
    border-radius: 6px;
  }

  .answer_shortAnswer_upload_icon {
    font-size: 28px;
    color: #303133;
  }

  .answer_shortAnswer_text {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .answer_shortAnswer_text_input {
    width: 100%;
  }

  .answer_shortAnswer_text_input.is-disabled /deep/ .el-input__inner {
    background-color: #F9F9FA;
    border-color: #D3D3D5;
  }
</style>